import './sentry';
import './polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'react-datepicker/dist/react-datepicker.css';
import 'tippy.js/dist/tippy.css';
import 'styles/index.css';
import Layout from 'components/Layout';
// import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from 'redux/store';
import './i18n';
import { FlashMessagesProvider } from 'hooks/useFlashMessages';
import { HelmetProvider } from 'react-helmet-async';
import { LumenIconProvider } from '@photoshelter/socialie-components';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <FlashMessagesProvider>
          <LumenIconProvider spritePath="/sprite.svg">
            <Layout />
          </LumenIconProvider>
        </FlashMessagesProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
